import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useFetch } from '@reveni-io/reveni-ui'

import { customerEmailCopies } from '@/common/components/SendEmailDrawer/constants'
import { statuses } from '@/returns/constants'
import returnsServices from '@/returns/services/services'

import { parseCcEmails } from './helpers'
import { transformRequestSendReturnEmail } from './transformers'

const useSendEmail = ({ returnId, customerEmail, storeReplyToEmail, returnStatus, setToastInfo, refetchReturn }) => {
  const { t } = useTranslation()
  const [showSendEmailModal, setShowSendEmailModal] = useState(false)
  const [to, setTo] = useState('')
  const [cc, setCc] = useState('')
  const [replyTo, setReplyTo] = useState('')
  const [subject, setSubject] = useState('')
  const [body, setBody] = useState('')

  const { fetchData, loading } = useFetch(returnsServices.sendReturnEmail, {
    doInitialRequest: false,
    transformRequest: transformRequestSendReturnEmail,
  })

  useEffect(() => {
    if (!showSendEmailModal) {
      setTo('')
      setCc('')
      setReplyTo(storeReplyToEmail || '')
      setSubject('')
      setBody('')
    }
  }, [showSendEmailModal, storeReplyToEmail])

  const onSendEmail = async () => {
    const ccEmails = parseCcEmails(cc)

    try {
      await fetchData({ returnId, to, ccEmails, replyTo, subject, body })
      setShowSendEmailModal(false)
      refetchReturn?.()
      setToastInfo?.({ type: 'success', message: t('Email enviado correctamente') })
    } catch (error) {
      setToastInfo?.({ type: 'error', message: error?.message })
    }
  }

  const openSendEmailModalForContactCustomer = () => {
    setShowSendEmailModal(true)
    setTo(customerEmail || '')
  }

  const closeSendEmailModal = () => {
    setShowSendEmailModal(false)
  }

  const allowSendEmail = returnStatus !== statuses.cancelled

  return {
    showSendEmailModal,
    openSendEmailModalForContactCustomer,
    closeSendEmailModal,
    to,
    setTo,
    cc,
    setCc,
    replyTo,
    setReplyTo,
    subject,
    setSubject,
    body,
    setBody,
    onSendEmail,
    loading,
    copies: customerEmailCopies,
    allowSendEmail,
  }
}

export default useSendEmail
